import axios, { AxiosInstance } from 'axios';

const TIMEOUT: number = 20000;

export class Api {
    protected instance: AxiosInstance;

    constructor(baseUrl: string, suffixUrl: string, headers: any) {
      this.instance = axios.create({
        baseURL: baseUrl + suffixUrl,
        timeout: TIMEOUT,
        headers,
      });
    }

    setHeaders(headers: any): void {
      this.instance.defaults.headers = headers;
    }

    setBearer(bearer: string): void {
      const header = this.instance.defaults.headers;
      header.Authorization = `Bearer ${bearer}`;
      this.setHeaders(header);
    }
}

export default Api;
